import VolumeSetting from './VolumeSetting'

export default VolumeSetting
